import { ButtonLink } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

export const OuterContainer = styled.div`
  width: 100%;
`

export const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 8px;
  height: 80px;
  border: 1px solid #71727a;
`

export const Actions = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 24px;
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const FileInformationText = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  text-align: center;
  font-size: 14px;
  margin-top: 14px;
  margin-bottom: 14px;
`

export const FileAttachIcon = styled.img<{ $fileSizeError?: boolean }>`
  display: block;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  ${({ $fileSizeError }) =>
    $fileSizeError ? 'filter: hue-rotate(137deg) saturate(39.39) brightness(92.35%);' : ''}
`

export const SubmittedDate = styled.h4`
  font-weight: 400;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 2px;
  margin-left: 30px;
`

export const Form = styled.form`
  width: 100%;
`

export const Email = styled.a`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  text-align: center;
  font-size: 14px;
  margin-top: 14px;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
`

export const RemoveButton = styled(ButtonLink)`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-decoration: underline;
  margin-right: 33px;
`
